
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.937 6.172l6.238 6.342H2.937v2.739h9.075l6.238 6.343 1.135-1.153L4.072 5.019zm16.731 6.342h1.419v2.739h-1.419zm-2.268 0h1.418v2.739h-1.419zm.85-7.351a4.123 4.123 0 0 0 .851-2.306h-1.418a1.739 1.739 0 0 1-1.7 1.729v1.442a3.665 3.665 0 0 1 3.548 3.747v1.874h1.418V9.775a4.73 4.73 0 0 0-2.699-4.612zm-3.97 3.459h1.418a1.8 1.8 0 0 1 1.843 1.874v1.153h1.418v-1.445a3.025 3.025 0 0 0-3.119-2.882h-1.419a1.875 1.875 0 0 1-1.7-1.874 1.539 1.539 0 0 1 1.7-1.586V2.424a3.02 3.02 0 0 0-2.977 3.027 3.03 3.03 0 0 0 2.836 3.171zm2.269 6.63v-2.738h-2.694z"}})])
          )
        }
      }
    